<template>
  <div class="VideoPlayer">
    <video ref="videoPlayer" class="video-js"></video>
  </div>
</template>

<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'

export default {
  name: 'VideoPlayer',

  props: {
    src: [String]
  },

  data() {
    return {
      player: null
    }
  },

  mounted() {
    this.init()
  },

  beforeDestroy() {
    if (this.player) {
      this.player.dispose()
      this.player = null
    }
  },

  methods: {
    init() {
      const { height, width } = this.$el.getBoundingClientRect()
      const options = {
        autoplay: true,
        controls: true,
        height: Math.ceil(height),
        width: Math.ceil(width),
        sources: [{ src: this.src }]
      }
      this.player = videojs(this.$refs.videoPlayer, options, () => {
        // console.log('onPlayerReady', this)
      })
    },

    play() {}
  }
}
</script>

<style lang="stylus" scoped>
.VideoPlayer
  height: 100%
  width: 100%
</style>
